import Tracker from 'tracks/tracker';
import { formatImpression } from '@weee-fe/weee-biz-web';
import { NewTracking } from '@/constants/track';
import { getLastURLParam } from '@/utils/url';

const formatParam = param => {
  return {
    mod_nm: param?.mod_nm ?? null,
    mod_pos: param?.mod_pos ?? null,
    sec_nm: param?.sec_nm ?? null,
    sec_pos: param?.sec_pos ?? null,
    co: param?.co,
    ctx: {
      ...(param?.ctx || {}),
      tag_key: undefined,
      tag_name: undefined
    }
  };
};

const formatProductInfo = data => {
  if (!data) return null;
  // 购物车返回的接口数据产品没有is_presale/ sale_event_id字段， 需要从refer_type/ refer_value获取
  const isPreSale = data?.refer_type?.includes('presale') ? true : data?.is_presale ? true : false;
  const saleEventId =
    isPreSale && data?.refer_value ? data?.refer_value : data?.sale_event_id ? data?.sale_event_id : null;
  // 增加extra_attrs处理逻辑
  let parsedExtraAttrs = null;

  if (data?.extra_attrs) {
    try {
      parsedExtraAttrs = JSON.parse(data.extra_attrs);
    } catch (error) {
      console.error('Failed to parse extra_attrs:', error);
    }
  }

  // 加购广告商品，co增加url、utm_campaign参数
  let adsParams = {};
  if (data?.ads_creative && data?.ads_creative?.trackRedirectUrl) {
    const utmCampaign = getLastURLParam(data.ads_creative.trackRedirectUrl, 'utm_campaign');
    adsParams = {
      url: data.ads_creative.trackRedirectUrl,
      ...(utmCampaign && { utm_campaign: utmCampaign })
    };
  }

  return {
    prod_pos: data?.index,
    prod_id: data?.id || data?.product_id,
    old_qty: data?.old_qty || 0,
    new_qty: data?.quantity,
    refer_type: data?.refer_type,
    source: data?.source,
    is_mkpl: data?.biz_type === 'seller',
    is_fbw: data?.biz_type === 'fbw' ? true : false,
    recommendation_trace_id: data?.recommend_trace_id || data?.recommendation_trace_id,
    tag_key: data?.tag_key,
    tag_name: data?.tag_name,
    volume_price_support: data?.volume_price_support ? true : false,
    biz_type: data?.biz_type || void 0,
    is_sponsored: !!data?.is_sponsored,
    is_presale: isPreSale,
    sale_event_id: saleEventId,
    is_manual: data?.is_manual || false,
    extra_attrs: parsedExtraAttrs,
    is_subscribe: data?.is_subscribe || void 0,
    coupon_type: data?.coupon_type,
    coupon_value: data?.coupon_value,
    ...adsParams
  };
};

export default function useCartActionT2(trackDataInDialog?: Record<string, any>) {
  const cartActionTracking = param => {
    const params = formatParam(param);
    params.co = formatProductInfo(params?.co);
    params.ctx = formatImpression.formatCtx(params?.ctx);
    if (params?.ctx === null) delete params.ctx;
    if (trackDataInDialog) {
      new Tracker().addEventInDialog(NewTracking.cartAction, params, trackDataInDialog).send();
    } else {
      new Tracker().addEvent(NewTracking.cartAction, params).send();
    }
  };

  return {
    cartActionTracking
  };
}
